import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSolidLike = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.56 3.10156C9.37 3.10156 10.99 3.98156 12 5.33156C13.01 3.98156 14.63 3.10156 16.44 3.10156C19.51 3.10156 22 5.60156 22 8.69156C22 9.88156 21.81 10.9816 21.48 12.0016C19.9 17.0016 15.03 19.9916 12.62 20.8116C12.28 20.9316 11.72 20.9316 11.38 20.8116C8.97 19.9916 4.1 17.0016 2.52 12.0016C2.19 10.9816 2 9.88156 2 8.69156C2 5.60156 4.49 3.10156 7.56 3.10156Z",
		fill: "#7548F0"
	})
});
export default SvgSolidLike;
